(() => {
  if (window.TailiTrustSection?.initAll) {
    window.TailiTrustSection.initAll();
    return;
  }

  const instances = new Map();
  const sectionSelector = '[data-taili-trust]';

  function setStaticState(root) {
    root.classList.add('is-entered');
    root.querySelectorAll('[data-trust-material-plane]').forEach((plane) => {
      plane.style.opacity = '1';
      plane.style.visibility = 'visible';
      plane.style.transform = 'none';
    });
  }

  function initTrust(root) {
    if (!root || root.dataset.trustInitialized === 'true') return;
    root.dataset.trustInitialized = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const gsapReady = typeof window.gsap !== 'undefined';
    const planes = Array.from(root.querySelectorAll('[data-trust-material-plane]'));
    const shadow = root.querySelector('.taili-trust__material-shadow');

    if (reducedMotion || !gsapReady || planes.length !== 4) {
      setStaticState(root);
      return;
    }

    const gsap = window.gsap;
    const cleanupCallbacks = [];
    const lift = [
      { x: -1.5, y: -12, z: 30, rotationX: -1.55 },
      { x: -0.8, y: -8.5, z: 20, rotationX: -1.05 },
      { x: -0.3, y: -5, z: 11, rotationX: -0.62 },
      { x: 0, y: -2.5, z: 5, rotationX: -0.3 }
    ];
    const rebound = [
      { y: -2.2, z: 5, rotationX: -0.3 },
      { y: -1.5, z: 3.5, rotationX: -0.2 },
      { y: -0.8, z: 2, rotationX: -0.12 },
      { y: -0.3, z: 1, rotationX: -0.06 }
    ];

    root.classList.add('is-material-motion-ready');
    gsap.set(planes, {
      x: 0,
      y: 0,
      z: 0,
      rotationX: 0,
      transformPerspective: 1000,
      transformOrigin: '72% 48%',
      force3D: true
    });
    gsap.set(shadow, { y: 12, scale: 0.97, autoAlpha: 0.16 });

    const motionTimeline = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 1.4,
      defaults: { overwrite: 'auto' }
    });

    planes.forEach((plane, index) => {
      motionTimeline.to(plane, {
        ...lift[index],
        duration: 1.05,
        ease: 'power2.inOut'
      }, index * 0.1);
    });
    motionTimeline.to(shadow, {
      y: 18,
      scale: 0.95,
      autoAlpha: 0.22,
      duration: 1.05,
      ease: 'power2.inOut'
    }, 0);

    [...planes].reverse().forEach((plane, reverseIndex) => {
      motionTimeline.to(plane, {
        x: 0,
        y: 0,
        z: 0,
        rotationX: 0,
        duration: 0.95,
        ease: 'power2.inOut'
      }, 1.65 + reverseIndex * 0.09);
    });
    motionTimeline.to(shadow, {
      y: 12,
      scale: 0.97,
      autoAlpha: 0.16,
      duration: 0.95,
      ease: 'power2.inOut'
    }, 1.65);

    planes.forEach((plane, index) => {
      motionTimeline
        .to(plane, {
          ...rebound[index],
          duration: 0.26,
          ease: 'power2.out'
        }, 2.9 + index * 0.04)
        .to(plane, {
          x: 0,
          y: 0,
          z: 0,
          rotationX: 0,
          duration: 0.38,
          ease: 'sine.out'
        }, 3.18 + index * 0.04);
    });

    let started = false;
    const startMotion = () => {
      if (!started) {
        started = true;
        root.classList.add('is-material-motion-running');
        motionTimeline.play(0);
      } else {
        motionTimeline.resume();
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          startMotion();
        } else if (started && !entry.isIntersecting) {
          motionTimeline.pause();
        }
      }, { threshold: [0, 0.2] });
      observer.observe(root);
      cleanupCallbacks.push(() => observer.disconnect());
    } else {
      startMotion();
    }

    instances.set(root, () => {
      cleanupCallbacks.forEach((callback) => callback());
      motionTimeline.kill();
      gsap.killTweensOf([shadow, ...planes]);
      instances.delete(root);
    });
  }

  function initAll(scope = document) {
    if (scope.matches?.(sectionSelector)) initTrust(scope);
    scope.querySelectorAll(sectionSelector).forEach(initTrust);
  }

  window.TailiTrustSection = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(sectionSelector)
      ? event.target
      : event.target.querySelector(sectionSelector);
    instances.get(root)?.();
  });
})();
